import { RouteRecordRaw } from 'vue-router';

export const useCaseRoute: RouteRecordRaw = {
  path: '/usecases/:useCaseId',
  name: 'UseCaseView',
  component: () => import('@/modules/UseCase/views/UseCaseView.vue'),
};

// So usecases can have sub-routes
export const catchAllUseCaseRoute: RouteRecordRaw = {
  path: '/usecases/:useCaseId/:pathMatch(.*)*',
  name: 'UseCaseViewMatchAll',
  component: () => import('@/modules/UseCase/views/UseCaseView.vue'),
};
